<button class="btn btn-primary" 
[attr.id]="'searchCaseModalOpener'+ uniqueId"
data-toggle="modal" [attr.data-target]="'#searchCaseModal' + uniqueId" (click)="isSearching = true;this.getCases()" [ngClass]="{'btn-sm': !!small, 'd-none':options.hideSearch}" [ngStyle]="{'visibility': !chosenCase ? 'visible' : 'hidden'}">{{ !!default ? (default | translate) : ('Standard.Search' | translate) + ' ' +  (('Standard.Case' | translate ) | lowercase ) }}</button>
<button class="btn btn-primary" *ngIf="chosenCase != null && !options.hideSearch" (click)="chosenCase = null; chosen.emit(null)" [ngClass]="{'btn-sm': !!small}">
  <div *ngIf="chosenCase.externalId != null && chosenCase.externalId != '' && chosenCase.caseNumber == null">{{ chosenCase.externalId }}</div>
  <div *ngIf="chosenCase.caseNumber != null">{{ chosenCase.caseNumber }}</div>
  <div>
    <b *ngIf="chosenCase.deliveryAddress.name">{{ chosenCase.deliveryAddress.name }}</b>
    <b *ngIf="!chosenCase.deliveryAddress.name">{{ chosenCase.customer.name }}</b>
  </div>
  <div>{{ chosenCase.deliveryAddress.zipCode}} {{ chosenCase.deliveryAddress.city}}</div>
</button>

<div class="modal" [attr.id]="'searchCaseModal' + uniqueId" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header p-3">
        <h5 class="modal-title">{{ 'Standard.Search' | translate }} {{ ('Standard.Case' | translate ) | lowercase }}</h5>
        <button type="button" class="close" (click)="close(); isSearching = false" aria-label="Close">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 11L11 1M1 1L11 11" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
        </button>
      </div>
      <div class="modal-body p-3" *ngIf="isSearching">
        <div class="row">
          <div class="col-6 d-flex">
            <input class="form-control" type="text" name="cases" [(ngModel)]="whichCase" (keyup)="filter()" (blur)="filter()" placeholder="{{ 'Standard.Search' | translate }} {{ ('Standard.Case' | translate ) | lowercase }}" />
            <button class="btn btn-success col-2 ml-1" (click)="getCases()">{{ 'Standard.Search' | translate }}</button>
          </div>
        </div>
        <!--Case List-->
        <div class="row mt-1 caseList">
          <div class="col-12" *ngIf="!!output && output.length > 0">
            <div class="row cursor-pointer" *ngFor="let x of output | slice:0:20" (click)="chooseCase(x)" data-dismiss="modal">
              <div class="col-12 d-flex justify-content-between">
                <div class="d-flex">
                  <div *ngIf="!!x.caseNumber">{{ 'Standard.Case' | translate }} {{ x.caseNumber }}</div>
                </div>
                <div class="d-flex flex-column">
                  <div class="d-flex"><b class="mr-1">{{ 'Standard.Responsible' | translate}}</b> {{ x.responsible }}</div>
                </div>
              </div>
              <div class="col-12 d-flex flex-column mb-1">
                <div *ngIf="!!x.title && x.title != '-'"><strong>{{ x.title }}</strong></div>
                <div class="card-description">{{ x.description }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer p-3 text-right">
        <div class="col-3">
          <button type="button" class="btn btn-secondary" (click)="close()">{{ 'Buttons.Close' | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>
